<template>
  <section class="content-ebooks">
    <div class="content-ebooks-itens">
      <Breadcrumb :links="links"/>
      <div class="content-ebooks-itens-body">
        <div class="row">
          <div class="col-12 col-sm-6 col-lg-4 col-xl-3">
            <router-link tag="a" :to="{name: 'RegisterEbooks'}" class="content--card-register" style="min-height: 276px">
              <img class="img-fluid" src="@/assets/img/image-plus.png" alt="image plus" title="image plus"/>
            </router-link>
          </div>
          <div class="col-12 col-sm-6 col-lg-4 col-xl-3" v-for="ebook in ebooks.data" :key="ebook.id">
            <CardEbook :ebook="ebook"/>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Breadcrumb from '@/components/breadcrumb/Index'
import CardEbook from '@/views/Ebooks/components/CardEbook';
import { mapGetters, mapActions } from 'vuex';

export default {
  data() {
    return {
      links: [
        {
          name: 'Ebooks',
          routerName: 'Ebooks'
        },
        {
          name: 'Listar Ebooks',
          routerName: 'ListEbooks'
        },
      ],
    }
  },
  computed: {
    ...mapGetters({
      ebooks: 'Ebooks/ebooks'
    })
  },
  components: {
    Breadcrumb,
    CardEbook
  },
  methods: {
    ...mapActions('Ebooks', ['consultEbooks'])
  },
  mounted() {
    this.consultEbooks();
  }
}
</script>

<style lang="scss" scoped>
.content--card-register {
  border-radius: 20px;
}
</style>
